import { ClientsService } from '../services'

export default (idPJ, ubos) => {
    return new Promise(async (resolve, reject) => {
        await ClientsService.updateMallaPropiedad(idPJ, ubos)
            .then(response => resolve(response.data))
            .catch(err => reject({ error: true }))
    })
}
